import { render } from "./TopHead.vue?vue&type=template&id=1ded5be0"
const script = {}

const cssModules = {}
import style0 from "./TopHead.vue?vue&type=style&index=0&id=1ded5be0&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/musubisumu/tex/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__